import React, { useState,    } from "react";
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import axios from 'axios';
import {  FROM_EMAIL , CAPTCHA_SECRET_KEY, TO_EMAIL, CC_EMAIL, EMAIL_SUBJECT, MAIN_PRICE, PATTERN_PRICE, RDS_POCKET_PRICE,   CELL_PHONE_POCKET } from '../Constants';
import ColorsList, { patternOptions } from '../Common';
import { fabric } from "fabric";
import ReactRecaptcha3 from 'react-google-recaptcha3';


const FitType = {
  "mens-fit-2": "Men's Fit",
  "womens-fit-1": "Women's Fit",
  "": ""
}
const SizeType = {
  "xs-1": "XS",
  "small-2": "Small",
  "medium-3": "Medium",
  "large-4": "Large",
  "xl-5": "XL",
  "xxl-6": "XXL",
  "": ""
}

export const SendDesignViaMail = (DataURLOFCANVAS ,EnterEmail,ColorFiller,contrastStiching , splitTorso , patterns , Fit ,Size , grippper , pocket ,IsCellPhoneZipperPocket ,isAreaTowPatterns ,isAreaThreePatterns ,userName) => {
  debugger




  var data = new FormData();
  data.append('from', FROM_EMAIL);
  if(EnterEmail === ""){
    data.append('to', TO_EMAIL);
    data.append('cc', CC_EMAIL);
  } else {

    data.append('to', EnterEmail);
  }
  // data.append('subject', EMAIL_SUBJECT);
  if(!!userName && userName !== ""){
  data.append('subject', `${EMAIL_SUBJECT} ${userName}`);
    
  } else {
    data.append('subject', `${EMAIL_SUBJECT} ${EnterEmail}`);

  }
  let patternHTML = addPatternWithCodeInHTML(patterns);
  let html = `
<h4>Shorts Design requirements: </h4>
<div>
    ${!!userName && userName !== "" ? `<div style="margin-bottom:5px"><span>Client First and Last Name  : ${userName}</span></div>` : ""}
      <div style="margin-bottom:5px"><span>RDS Pocket : ${pocket}</span></div>
      <div style="margin-bottom:5px"><span>Fit : ${FitType[Fit]}</span></div>
      <div style="margin-bottom:5px"><span>Size : ${SizeType[Size]}</span></div>
      <div style="margin-bottom:5px"><span>Cell Phone Zipper Pocket : ${IsCellPhoneZipperPocket}</span></div>
      <div style="margin-bottom:5px"><span style="display:flex;align-items:baseline;"> Contrast Stiching : <span style="margin-right:15px">${contrastStiching}</span>  </span></div>
      <br />
      <div style="margin-bottom:5px"><span style="display:flex;align-items:baseline;">Area 1 &nbsp; &nbsp;:&nbsp; &nbsp; ${addColorWithCodeInHTML(ColorFiller.find(i => i.key === "v1").value)}</span></div>
      <br />
      <div style="margin-bottom:5px"><span style="display:flex;align-items:baseline;">Area 2 &nbsp; &nbsp;:&nbsp; &nbsp; ${isAreaTowPatterns === true ? patternHTML.html : addColorWithCodeInHTML(ColorFiller.find(i => i.key === "v2").value)}</span></div>
      <br />
      <div style="margin-bottom:5px"><span style="display:flex;align-items:baseline;">Area 3 &nbsp; &nbsp;:&nbsp; &nbsp; ${isAreaThreePatterns === true ? patternHTML.html : addColorWithCodeInHTML(ColorFiller.find(i => i.key === "v3").value)}</span></div>        
</div>
`
  console.log(html)
  let gfi = dataURLtoFile(DataURLOFCANVAS, "image.jpeg");
  data.append('html', html);
  data.append('attachment', gfi);
  // if(isAreaTowPatterns === true  || isAreaThreePatterns === true){
  //  data.append('inline',patternHTML.url );

  // }

  var config = {
    method: 'post',
    url: 'https://api.mailgun.net/v3/threeringdev.com/messages',
    headers: {
      'Authorization': 'Basic YXBpOmZlNzM2OWU0YjgzZTIzZWE1ZmZhMTZkMzI0ZDBkN2ZhLTZkOGQ0MjhjLTg5N2NkYWM1',
    },
    data: data
  };

  axios(config)
    .then(function (response) {
      debugger
      console.log(JSON.stringify(response.data));
      EnterEmail === "" ? console.log("Email Sent Successfully!") : alert("Email Sent Successfully!");
    })
    .catch(function (error) {
      debugger
      console.log(error);
    });

}


const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

const addColorWithCodeInHTML = (color) => {
  let code = ColorsList.find(x => x.value === color)?.code;
  let name = ColorsList.find(x => x.value === color)?.name;
  return `<div style="display:flex;align-items:baseline;"><div style="width:100px;height:100px;background-color:${color}"></div> &nbsp; &nbsp; ${code} ,&nbsp; &nbsp; ${name}</div>`
}
const addPatternWithCodeInHTML = (patterns) => {
  const patternList = {
    "Green_Galaxy": "https://kuasky.com/apps/patterns/greengalaxy.png",
    "Ammo_Cammo": "https://kuasky.com/apps/patterns/ammocammo.png",
    "Pineapple_Express": "https://kuasky.com/apps/patterns/pineappleexpress.png",
    "Pink_Graffitti": "https://kuasky.com/apps/patterns/pinkgraffitti.png",
    "Black_Camo": "https://kuasky.com/apps/patterns/blackcamo.png",
    "Purple_haze": "https://kuasky.com/apps/patterns/purplehaze.png",
    "Blue_Graffitti": "https://kuasky.com/apps/patterns/bluegraffitti.png",
    "Pink_Galaxy": "https://kuasky.com/apps/patterns/pinkgalaxy.png",
    "Water_Color": "https://kuasky.com/apps/patterns/watercolor.png",
    "Cammo": "https://kuasky.com/apps/patterns/camo.png",
    "Purple_Galaxy": "https://kuasky.com/apps/patterns/purplegalaxy.png",
    "Red_Haze": "https://kuasky.com/apps/patterns/redhaze.png",
    "Spring_Break": "https://kuasky.com/apps/patterns/springbreak.png",
    "Zombie_Unicorn_2": "https://kuasky.com/apps/patterns/zombieunicorn4.png",
    "Stripes": "https://kuasky.com/apps/patterns/stripes.png",
    "Blue_Rock_Candy": "https://kuasky.com/apps/patterns/bluerockcandy.png",
    "Sugar_Skull_2": "https://kuasky.com/apps/patterns/sugarskull4.png",
    "Sugar_rush": "https://kuasky.com/apps/patterns/sugarrush.png",
    "Red_Rockcandy": "https://kuasky.com/apps/patterns/redrockcandy.png",
    "Lemonade": "https://kuasky.com/apps/patterns/lemonade.png",
    "Radbows": "https://kuasky.com/apps/patterns/radbows.png",
  }
  return { html: `<div style="display:flex;align-items:baseline;"><img src="${patternList[patterns]}" style="width:100px;height:100px;" /> ,  ${patternOptions[patterns]}</div>`, url: patternList[patterns] }
}





function SavedDesingList() {
  const [DataURLOFCANVAS, setDataURLOFCANVAS] = useState('');
  const [EnterEmail, setEnterEmail] = useState("");

  var ColorFiller = useSelector(state => state.auth.SuitPartsList);


  var grippper = useSelector(state => state.auth.IsGripper);
  var pocket = useSelector(state => state.auth.IsPocket);
  var contrastStiching = useSelector(state => state.auth.IsContrastStiching);
  var IsCellPhoneZipperPocket = useSelector(state => state.auth.IsCellPhoneZipperPocket);
  var splitTorso = useSelector(state => state.auth.IsSplitTorso);
  var patterns = useSelector(state => state.auth.PatternValue);
  var isAreaTowPatterns = useSelector(state => state.auth.IsAreaTowPatterns);
  var isAreaThreePatterns = useSelector(state => state.auth.IsAreaThreePatterns);
  var Fit = useSelector(state => state.auth.fit);
  var Size = useSelector(state => state.auth.size);
  var downloadimgSrc = useSelector(state => state.auth.downloadImageSrc);
  var svgRef = useSelector(state => state.auth.svgRef);
  var fabricCanvasInstance = useSelector(state => state.auth.globalCanvas);

  let dispatch = useDispatch();







  const setDATAURL = () => {

    if (!validateEmail(EnterEmail)) {
      alert("Please Enter Valid Email");
      return false;
    }


    fabric.loadSVGFromString(svgRef.innerHTML, function (objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      debugger
      obj.scaleToHeight(fabricCanvasInstance.height - 10)
        .set({ left: 0, top: 0, width: fabricCanvasInstance.width + 20, backgroundColor: "yellow" })
        .setCoords();
      fabricCanvasInstance.add(obj).renderAll();

      fabricCanvasInstance.setBackgroundColor('rgba(255, 255, 255, 1)', fabricCanvasInstance.renderAll.bind(fabricCanvasInstance));
      let dt = fabricCanvasInstance.toDataURL({
        format: 'jpeg',
        quality: 1,
      })
      console.log(dt);
      ReactRecaptcha3.getToken().then(
        (token) => {
          console.log(token);
          onVerify(token , dt)
          
        },
        (error) => {
          console.log(error);
        }
      );

      SendDesignViaMail(dt,EnterEmail,ColorFiller,contrastStiching , splitTorso , patterns , Fit ,Size , grippper , pocket ,IsCellPhoneZipperPocket ,isAreaTowPatterns ,isAreaThreePatterns)
      setDataURLOFCANVAS(dt)


    });
  }

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const onVerify =(recaptchaToken , dt) => {

    var config = {
      method: 'get',
      url: `https://www.google.com/recaptcha/api/siteverify?secret=${CAPTCHA_SECRET_KEY}&response=${recaptchaToken}`,
    };
  
    axios(config)
      .then(function (response) {
        debugger
        console.log(JSON.stringify(response));
        if(response.success === true){
          SendDesignViaMail(dt,EnterEmail,ColorFiller,contrastStiching , splitTorso , patterns , Fit ,Size , grippper , pocket ,IsCellPhoneZipperPocket ,isAreaTowPatterns ,isAreaThreePatterns)
        } else {
          alert("Invalid Captcha")
        }
      })
      .catch(function (error) {
        debugger
        console.log(error);
      });
  };

  return (
    <>
      <Row>
        <Col md={4} xs={12}>
          
          <input type='email' value={EnterEmail} onChange={(e) => setEnterEmail(e.target.value)} className='form-control mt-2' placeholder='Enter your email' />
        </Col>
        <Col md={8} xs={12}>

          <div className='d-flex align-items-center justify-content-between mt-2'>

            <div className='text-start'>
              {/* <Button variant="primary" className='me-1' onClick={() => { SaveSelectedDesign(); setDATAURL() }}>Send Design To Email</Button> */}
              <Button disabled={EnterEmail !== "" ? false : true} variant="primary" className='me-1' onClick={() => { setDATAURL() }}>Save Design To Email</Button>
              {/* <Button variant="danger" onClick={() => ClearSavedlist()}>Delete</Button> */}
            </div>
            <b> Price: ${

              parseFloat((parseFloat(MAIN_PRICE)) + ((isAreaThreePatterns === true || isAreaTowPatterns === true) ? parseFloat(PATTERN_PRICE) : parseFloat(0))
                + ((pocket === 'yes') ? parseFloat(RDS_POCKET_PRICE) : parseFloat(0))
                + ((IsCellPhoneZipperPocket === 'yes') ? parseFloat(CELL_PHONE_POCKET) : parseFloat(0))
              ).toFixed(2)

            } </b>
          </div>
        </Col>


      </Row>
    </>
  );
}

export default SavedDesingList;